import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=618a226e&scoped=true"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"
import style0 from "./navigation.vue?vue&type=style&index=0&id=618a226e&prod&lang=less"
import style1 from "./navigation.vue?vue&type=style&index=1&id=618a226e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618a226e",
  null
  
)

export default component.exports